import FieldProject from "../../../generic/entity/project/project";
import FieldConfig from "../../../../fields3/proto/field-config";
import FieldTaskParent_CSVImportPreview from "./render/csv-import-preview";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";

export default class FieldTaskParent extends FieldProject {


    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Task project";
        this.icon           = 'ii5-project';

        this.variableName   = '{TASK-PROJECT}'


        this.renderComponents.csvImportPreview  = FieldTaskParent_CSVImportPreview
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        const projectId = super.normalizeFromCSVValue(value, module)

        // workspace can't be task parent (no tasks in workspace root)
        return gd.spaces.workspaces.getByProjectId(projectId) ? null : projectId
    }
}
